<div class="dialog">
  <h4 mat-dialog-title>{{ local_data.message }}</h4>
  <div class="dialog-box-s">
    <mat-dialog-content style="width: 100%; justify-self: anchor-center;" class="mt-4">

      @if (hasAiItems) {
      <div class="ai-items-warning">
        <mat-icon class="ai-warn-icon">auto_awesome</mat-icon>
        <span>{{ variables?.aiItemsWarning || 'Esta estimación contiene elementos generados por IA. Revísalos antes de guardar.' }}</span>
      </div>
      }
      @if (!showJustificationInput) {
        <div class="button-group">
          @if (!showJustificationInput) {
            <app-button typeBtn="secondary" color="red"
            message="{{variables.goBack}}" mat-dialog-close></app-button>
          }
          <app-button typeBtn="primary" message="{{variables.onGoing}}"
          (click)="doActionIsComplete(false)"></app-button>
          @if (hasTasks) {
            <app-button typeBtn="primary" message="{{variables.finished}}"
            (click)="toggleJustificationInput()"></app-button>
          }
        </div>
      }
      <br>
        @if (showJustificationInput) {
          <div>
            <p class="ps" style="width: 100%;">{{variables.haveSelectedCompletedBut}}</p>
            <mat-form-field appearance="fill" style="width: 100%;" appearance="outline">
              <textarea matInput placeholder="{{variables.justificationHere}}" [(ngModel)]="justification"
              required style="width: 100%;"></textarea>
              @if (!justification) {
                <mat-error>{{variables.itsMandatoryJustification}}</mat-error>
              }
            </mat-form-field>
            <br><br>
            <div class="button-group">
              <app-button typeBtn="secondary" color="red" message="{{variables.goBack}}"
              mat-dialog-close></app-button>
              <app-button typeBtn="primary" message="Confirmar" ng-disabled="!justification"
              (click)="doActionIsComplete(true)"></app-button>
            </div>
          </div>
        }
      </mat-dialog-content>
    </div>
    <!-- <section class="back-button">
    <app-button typeBtn="secondary" *ngIf="!showJustificationInput" color="red" message="{{variables.goBack}}" mat-dialog-close></app-button>
  </section> -->
</div>